import { render, staticRenderFns } from "./CustomerServiceForm.vue?vue&type=template&id=c5435674&scoped=true"
import script from "./CustomerServiceForm.vue?vue&type=script&lang=js"
export * from "./CustomerServiceForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceForm.vue?vue&type=style&index=0&id=c5435674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5435674",
  null
  
)

export default component.exports